import { v4 as uuidv4 } from 'uuid';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import Translation from '../../Translation/cont/Translation'
import { EDIT_PRINT_CAP } from '../../../constants/caps'
import ImageDisplayAndUpload from '../../forms/fields/ImageDisplayAndUpload'
import FieldWrapper from '../../forms/FieldWrapper'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import ButtonSubmitCancel from '../../general/ButtonSubmitCancel'
import { sanitizeFormInput, sanitizeFormOutput } from '../../../functions/formFunctions'
import WrapperAccordion from '../../general/WrapperAccordion';
import { withRouter } from 'react-router-dom';
import RadioButtonMovieItem from '../../forms/fields/SingleSelectRadioButtonMovieItem';
import RadioButtonGroup from '../../forms/fields/RadioButtonGroup';
import RadioButton from '../../forms/fields/SingleSelectRadiobutton';

const EditNewspaperElement = ({itemData, onUpdateItem, history, closePagePath, sortedMovieDataKeys, movieData, cinemaId}) => {
    const pageName = itemData && (itemData.name || itemData.pk)
        ? [itemData.name, <Translation key="edit" id="print_flyer_edit" before=" "/>] 
        : [<Translation key="new" id="content_default_title"/>] 

    const buttonsConfig = [
        {
            "value":"withPerformances",
            "transId": "print_newspaper_withPerformances_style"
        }, 
        {
            "value":"withoutPerformances",
            "transId": "print_newspaper_withoutPerformances_style"
        }
    ]

    return (
        <WrapperPageSimple pageTitle={pageName} closePagePath={closePagePath}>
            <div className="program-page flyer site-content">
                {itemData ? (
                    <Formik
                        initialValues={sanitizeFormInput(itemData)}
                        onSubmit={(values, actions) => {
                            if(!values.id) {
                                values.id = uuidv4()
                            }

                            onUpdateItem(sanitizeFormOutput(values))
                            history.push(closePagePath)
                        }}
                        
                        onReset={(values, actions) => {
                            history.push(closePagePath)
                        }}
                    >
                    {({ values, errors, status, touched, isSubmitting, handleReset, setFieldValue }) => (
                            <Form>
                                <WrapperAccordion
                                    className="single-section"
                                    selectionActiveClass="accordion-item-open"
                                >
                                    <fieldset>
                                        <div className="form-content newspaper">
                                            <div className="left-sections">
                                                 <FieldWrapper label={"Name"} id="newspaper-name" classes="field-text">
                                                    <Field type="text" name="name" id="newspaper-name" className="text-regular input-text-box" />
                                                    <ErrorMessage className="text-regular-color" name="name" component="div" /> 
                                                </FieldWrapper>
                                                <FieldWrapper classes="image field-text" label={<Translation id="logo"/>} id="newspaper-logo" >
                                                    <Field 
                                                        name="logo"
                                                        component={ImageDisplayAndUpload}
                                                    />
                                                </FieldWrapper>
                                                 <FieldWrapper label={<Translation id="style_newsletterBackground"/>} id="newspaper-background" classes="field-text gap-20">
                                                    <Field type="text" name="newspaperBackground" id="newspaper-background" className="text-regular input-text-box" />
                                                    <ErrorMessage className="text-regular-color" name="newspaperBackground" component="div" /> 
                                                </FieldWrapper>
                                                 <FieldWrapper label={<Translation id="print_flyer_text_color"/>} id="newspaper-text-color" classes="field-text gap-20">
                                                    <Field type="text" name="newspaperTextColor" id="newspaper-text-color" className="text-regular input-text-box" />
                                                    <ErrorMessage className="text-regular-color" name="newspaperTextColor" component="div" /> 
                                                </FieldWrapper>
                                                <RadioButtonGroup
                                                    label={<Translation id="highlight_movie_link" after="*">Filmverknüpfung</Translation>}
                                                    className="select-new-section-type gap-20"
                                                    >
                                                    <ErrorMessage className="text-regular-color movie-error" name="movieId" component="div" /> 
                                                    {buttonsConfig.map((buttonConfig, index) => {
                                                        const {value, transId} = buttonConfig
                                                        return (
                                                              <Field
                                                                key={index}
                                                                component={RadioButton}
                                                                name="style"
                                                                id={value}
                                                                label={<Translation id={transId}/>}
                                                            />
                                                        )
                                                    })}
                                                </RadioButtonGroup>
                                                {sortedMovieDataKeys && !_.isEmpty(movieData) && sortedMovieDataKeys.length > 0 ? (
                                                    <RadioButtonGroup
                                                        label={<Translation id="highlight_movie_link" after="*">Filmverknüpfung</Translation>}
                                                        className="select-new-section-type"
                                                        >
                                                        <ErrorMessage className="text-regular-color movie-error" name="movieId" component="div" /> 

                                                            {sortedMovieDataKeys.map((movieID) => {
                                                                const movie = movieData[movieID]
                                                                const intId = movie.id
                                                                const {cinemaIds, title} = movie
                                                                const containsCinema = _.contains(cinemaIds, cinemaId)
                                                                
                                                                if(containsCinema) {
                                                                    return (
                                                                        <Field
                                                                            key={intId}
                                                                            component={RadioButtonMovieItem}
                                                                            name="movieId"
                                                                            id={intId}
                                                                            movie={movie}
                                                                            label={title}
                                                                        />
                                                                    )
                                                                } else {
                                                                    return ''
                                                                }
                                                            })}
                                                    </RadioButtonGroup>
                                                ) : (
                                                    <p>Keine Filme verfügbar.</p>
                                                )}
                                            </div>
                                        </div>
                    
                                        <ButtonSubmitCancel
                                            transIdCancel="cancel_button"
                                            transIdSubmit="save_item_button"
                                            cap={EDIT_PRINT_CAP}
                                            disabledCancel={isSubmitting}
                                            disabledSubmit={isSubmitting}
                                            onCancel={handleReset}
                                        />
                                    </fieldset>
                                </WrapperAccordion>
                            </Form>
                        )}

                    </Formik>
                ) : (
                    <div><Translation id="no_data"/></div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default withRouter(EditNewspaperElement)